var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid px-0"},[(!_vm.$store.getters.isAuthenticated)?_c('LoginView',{attrs:{"deal-id":_vm.dealId}}):_c('div',{staticClass:"home"},[_c('HeaderComponent'),_c('DashboardView',{attrs:{"deal-id":_vm.dealId}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }